import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Message, FileUpload } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../employee/service/account/account.service';
import { UploadFilesService } from '../../../employee/service/upload-files/upload-files.service';
import { CandidateComponent } from '../../candidate.component';
import { config } from '../../../../../environments/config';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { User } from '../../../employee/class/user';
import { Candidate } from '../../../employee/class/candidate';

@Component({
  selector: 'app-account-candidate-edit',
  templateUrl: './account-candidate-edit.component.html',
  styleUrls: ['./account-candidate-edit.component.scss']
})
export class AccountCandidateEditComponent implements OnInit {
  public user: User;
  public edit = false;
  public editPass = false;
  public userEdit: User;
  public form: FormGroup;
  public formPassword: FormGroup;
  public email: AbstractControl;
  public language: AbstractControl;
  public current_password: AbstractControl;
  public password: AbstractControl;
  public confirmPassword: AbstractControl;
  public msgs: Message[] = [];
  public apiUrl = config.API_ROOT;
  public uploadedAvatar: any[] = [];
  public prewiewAvatar: any;
  public defaultAvatar: any;
  public avatar: any;
  public promiseSubmit: Promise<any>;
  public promiseAvatar: Promise<any>;
  public promisePass: Promise<any>;
  public langs= [
    { label: 'English', abr: 'en' },
    { label: 'Español', abr: 'es' },
  ];

  public candidate: Candidate;
  public fieldTextType: Boolean= false;
  public fieldTextType2: Boolean= false;
  public fieldTextType3: Boolean= false;

  constructor(
    fb: FormBuilder,
    public accountService: AccountService,
    public uploadFilesService: UploadFilesService,
    public translate: TranslateService,
    public candidateComponent: CandidateComponent,
    private _router: Router,
    private route: ActivatedRoute
  ) { 
    // this.form = fb.group({
    //   'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ])],
    //   'language': [],
    // });

    this.formPassword = fb.group({
      'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ])],
      'language': [],
      'current_password': ['', Validators.compose([ Validators.required, Validators.minLength(6) ])],
      'password': ['', Validators.compose([ Validators.required, Validators.minLength(6),Validators.pattern("^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9.*]+$") ])],
      'confirmPassword': ['', Validators.compose([ Validators.required, Validators.minLength(6) ])],
    });

    this.email = this.formPassword.controls['email'];
    this.language = this.formPassword.controls['language'];

    this.current_password = this.formPassword.controls['current_password'];
    this.password = this.formPassword.controls['password'];
    this.confirmPassword = this.formPassword.controls['confirmPassword'];

    this.defaultAvatar = require('../../../../../assets/images/Luciana.png');
    this.getProfile();
    this.getProfilePermissions();
  }

  ngOnInit() {
  }

  public onUpload(event: any) {
    this.uploadedAvatar = [];
    for (const file of event.srcElement.files) {
      this.uploadedAvatar.push(file);
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewAvatar = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateProfile(values) {
    event.preventDefault();
    
    const body = {
      'email': values.email,
      'language': values.language,
    };

    this.promiseSubmit = this.accountService.updateProfile(body).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push( { severity: 'success', summary: res  } );
        });
        this.getProfile();
        // this.candidateComponent.getAccountCandidate();
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: errorMsg  } );
      }
    );

    this.updatePassword(values);
  }

  public updatePassword(values) {
    event.preventDefault();

    const d = new Date();
    const body = {
      'current_password': values.current_password,
      'new_password': values.password,
      'password_change_at': d
    };

    this.promisePass = this.accountService.updatePassword(body).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push( { severity: 'success', summary: res  } );
        });
        alert("Contraseña actualizada exitosamente!");
        this.closeEditPass();
      },
      error => {
        let errorMsg = '';
        if ( error.status === 422  ) {
          this.translate.get('current password invalid').subscribe((res: string) => {
            errorMsg = res;
          });
        }
        if ( error.status === 500 )
          errorMsg = 'Error';
        
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: errorMsg  } );
      }
    );
  }

  public closeEditPass() {
    this.password.setValue('');
    this.current_password.setValue('');
    this.confirmPassword.setValue('');
    this.editPass = false;
    this._router.navigate(['candidate/curriculum']);
  }

  public getProfile() {
    this.accountService.getAccountCandidate().toPromise().then(
      response => {
        this.user = response.json();
        this.candidate = this.user.candidate;
        this.avatar = (this.user.avatar) ? this.user.avatar : this.defaultAvatar;
        this.edit = true;
        this.email.setValue(this.user.email);
        this.language.setValue(this.user.language);
        this.userEdit = this.user;
        // this.getAvatar();
      },
      error => {
        console.log(error.json());
      }
    );
  }

  public getProfilePermissions() {
    this.accountService.getAccountPermissions().toPromise().then(
      response => {
        this.user.permissions = response.json();
      },
      error => {
        console.log(error.json());
      }
    );
  }

  public checkPass(values) {
    if(values.password != values.confirmPassword)
      return false;
    if(values.password == values.current_password )
      return false;
    return true;  
  }

  toggleFieldTextType(field_password: number) {
    if(field_password == 1)
      this.fieldTextType = !this.fieldTextType;
    else if(field_password == 2)
      this.fieldTextType2 = !this.fieldTextType2;
    else if(field_password == 3)
      this.fieldTextType3 = !this.fieldTextType3;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/components/account-candidate-edit/account-candidate-edit.component.ts